import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { debug: String, client: String, redirect: String };
  static targets = [ "feedback", "allow", "initial", "reload" ];

  connect() {
    if (window.self === window.top) return this.redirect();

    var hasStorageAccess = document.hasStorageAccess?.();
    if (!hasStorageAccess) return this.redirect();

    hasStorageAccess.then(
      (hasAccess) => {
        if (hasAccess) return this.redirect();
        else {
          this.initialTarget.hidden = true;
          this.allowTarget.hidden = false;
        }
      },
      (reason) => {
        this.setError(reason);
      }
    );
  }

  allowThirdPartyCookies() {
    var promise = document.requestStorageAccess();

    promise.then(
      () => {
        // this.allowTarget.hidden = true;
        // this.reloadTarget.hidden = false;
        return window.location.reload();
      },
      () => {
        window.open(`/landings/auth/${this.clientValue}`, '_blank').focus();
        // this.setError("You need to allow the storage of thrid party cookies.");
      }
    );
  }

  setError(errorMessage) {
    this.feedbackTarget.hidden = false;
    this.feedbackTarget.innerHTML = `ERROR: ${errorMessage}`;
  }

  redirect() {
    if (this.debugValue != 'true') window.location = this.redirectValue || `${window.location.protocol}//${window.location.host}/`;
  }
}
